class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;
    this._setupHover();
  }

  _isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  _setupHover() {
    this._openTimer = null;

    this.addEventListener('mouseenter', () => {
      if (!this._isDesktop()) return;
      clearTimeout(this._closeTimer);
      // 120ms intent delay — quick pass-overs don't trigger the menu
      this._openTimer = setTimeout(() => {
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.setAttribute('open', '');
        }
      }, 120);
    });

    this.addEventListener('mouseleave', () => {
      if (!this._isDesktop()) return;
      clearTimeout(this._openTimer);
      this._closeTimer = setTimeout(() => this.close(), 150);
    });

    // Keep open when mouse enters the dropdown content
    const content = this.querySelector('.mega-menu__content, .header__submenu');
    if (content) {
      content.addEventListener('mouseenter', () => clearTimeout(this._closeTimer));
      content.addEventListener('mouseleave', () => {
        if (!this._isDesktop()) return;
        this._closeTimer = setTimeout(() => this.close(), 150);
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
